import React, { FC, useEffect } from "react";
import { useRouter } from "next/router";
import getConfig from "next/config";
import TagManager from "react-gtm-module";
import YandexMetrica from "common/YandexMetrica/YandexMetrica";
import { gtm } from "helpers/analytics";

const { publicRuntimeConfig } = getConfig();

const Analytics: FC = () => {
  // логика описана
  // https://zdravcity-protek.atlassian.net/wiki/spaces/~484917709/pages/300286202/Zdravcity#%D0%9F%D0%B5%D1%80%D0%B5%D1%85%D0%BE%D0%B4-%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8F-%D0%BD%D0%B0-%D1%81%D0%B0%D0%B9%D1%82
  const router = useRouter();
  const { TAG_MANAGER } = publicRuntimeConfig;

  useEffect(() => {
    router.events.on("routeChangeStart", () =>
      gtm.customReferrer(location.href)
    );
  }, [router.events]);

  useEffect(() => {
    if (TAG_MANAGER) {
      TagManager.initialize({
        gtmId: TAG_MANAGER,
        dataLayerName: "dataLayer",
        events: { "gtm.start": new Date().getTime(), event: "gtm.js" },
      });
      window.dataLayer = new Proxy(window.dataLayer || [], {
        set(
          target: typeof window.dataLayer,
          key: string | symbol,
          value: unknown
        ): boolean {
          if (!["length", "push"].includes(key as string)) {
            const pushEvent = new CustomEvent("datalayerpush", {
              detail: value,
            });

            window.dispatchEvent(pushEvent);
          }

          return Reflect.set(target, key, value);
        },
      });
      gtm.customReferrer(document.referrer);
      router.events.on("routeChangeComplete", gtm.pageView);
    }
  }, [TAG_MANAGER, router.events]);

  return (
    <>
      <YandexMetrica
        options={{
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true,
          ecommerce: "dataLayer",
        }}
      />
      {TAG_MANAGER && (
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${TAG_MANAGER}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          />
        </noscript>
      )}
    </>
  );
};

export default Analytics;
